import React, { Component } from "react"
import Context from "./Context"

export default class ContextProvider extends Component {
  state = {
    loggedIn: false,
    apiToken: null,
    user: null,
    availableRobots: [],
    scanRobots: false,
    availableTasks: localStorage.getItem("availableTasks") ?
      JSON.parse(localStorage.getItem("availableTasks"))
      : [],
    availableMissions: localStorage.getItem("availableMissions") ?
      JSON.parse(localStorage.getItem("availableMissions"))
      : [],
    availableTriggers: localStorage.getItem("availableTriggers") ?
      JSON.parse(localStorage.getItem("availableTriggers"))
      : [],
    availablePoints: [],
    selectedRobot: null,
    typeRobot: null,
    pointNames: [],
    drawTools: [
      { _id: 'select', name: 'Selector' },
      { _id: 'points', name: 'Navigation' },
      { _id: 'areas', name: 'Areas' },
      { _id: 'location', name: 'Here' }
    ],
    selectedUser: null,
    actionValueTypes: [{ name: "value" }, { name: "station" }],
    robotsValueTypes: [{ name: "UV-Robot" }, { name: "FI-250" }, { name: "Generic" }],
    robotsROSVersions: [{ name: "ROS1" }, { name: "ROS2" }],
    missionType: [{ name: "PickP" }, { name: "PickD" }, { name: "Drop" }, { name: "Charge" }],
    battery: null,
    availableActions: [
      { id: "go-to", name: "go-to", needs_value: true, valueType: "point" },
      { id: "go-to-line-follow", name: "go-to-line-follow", needs_value: true, valueType: "point" },
      { id: "stop", name: "stop", needs_value: false },
      { id: "follow", name: "follow", needs_value: false },
      { id: "pause", name: "pause", needs_value: true, valueType: "value" },
      { id: "rotate", name: "rotate", needs_value: true, valueType: "value" },
      { id: "select-map", name: "select-map", needs_value: true, valueType: "mapList" },
      { id: "desinfect", name: "desinfect", needs_value: true, valueType: "onOff" },
      { id: "desinfect-uv", name: "desinfect-uv", needs_value: true, valueType: "value" },
      { id: "desinfect-all", name: "desinfect-all", needs_value: true, valueType: "value" },
      { id: "timer", name: "timer", needs_value: true, valueType: "value" },
      { id: "loop", name: "loop", needs_value: true, valueType: "startEnd" },
      { id: "dock", name: "dock", needs_value: true, valueType: "docking" },
      { id: "release-magnet", name: "release-magnet", needs_value: false },
      { id: "lifter", name: "lifter", needs_value: true, valueType: "upDown" },
      { id: "check-orientation", name: "check-orientation", needs_value: false },
      { id: "orientate-to", name: "orientate-to", needs_value: true, valueType: "point" },
      { id: "orientate-to-drop", name: "orientate-to-drop", needs_value: true, valueType: "point" },
      { id: "orientate-to-charge", name: "orientate-to-charge", needs_value: true, valueType: "point" },
      { id: "undock-pallet", name: "undock-pallet", needs_value: false },
      { id: "undock-trolley", name: "undock-trolley", needs_value: false },
      { id: "orientate-to-fork", name: "orientate-to-fork", needs_value: true, valueType: "point" },
      { id: "fork", name: "fork", needs_value: true, valueType: "value" },
      { id: "release-charger", name: "release-charger", needs_value: false },
      { id: "bench-control", name: "bench-control", needs_value: true, valueType: "upDown" },
      { id: "publish-pose", name: "publish-pose", needs_value: false, value: "Base" },
      { id: "move", name: "move", needs_value: true, valueType: "value" }
      /*missão: "undock-pallet" - sem valor
      missão: "orientate-to-fork" - valor: pontos do mapa, como se fosse um "go-to"
      missão: "fork" - valor: float, de 0 a 3*/
    ],
    availableSubActions: [
      { name: "onOff", values: ["on", "off"] },
      { name: "startEnd", values: ["start", "end"] },
      { name: "docking", values: ["charger", "pallet", "qrCode", "trolley", "magnet"] },
      { name: "upDown", values: ["up", "down"] }
    ],
    firstLoad: true,
    modalState: { tasks: false, maps: false, configuration: false, settingsRemote: false, import: false, dashboard: false, dashboard_status: false, disconnect: false, import: false, missions: false, verification: false },
    importExcel: localStorage.getItem("importExcel") ? JSON.parse(localStorage.getItem("importExcel")) : [],
    robotConfiguration: localStorage.getItem("robotConfiguration") ? JSON.parse(localStorage.getItem("robotConfiguration")) : [],
    isRobotConnected: false,
    destinations: localStorage.getItem("destinations") ? JSON.parse(localStorage.getItem("destinations")) : [],
    // mapIndex: 0,
    mapIndex: localStorage.getItem("mapIndex") ? JSON.parse(localStorage.getItem("mapIndex")) : -1,
    maps: [],
    //maps: localStorage.getItem("maps") ? JSON.parse(localStorage.getItem("maps")) : [],
    mapFeed: null,
    mapOrientation: localStorage.getItem("mapOrientation") ? JSON.parse(localStorage.getItem("mapOrientation")) : {},
    currentTask: null,
    lastMission: null,
    foundPeople: false,
    palletHeight: 0,
    palletWeight: 0,
    currentMission: {},
    settings: localStorage.getItem("settings") ? JSON.parse(localStorage.getItem("settings")) : {},
    endOfMission: false,
    orderStatus: null,
    robotInfo: {},
    message: "",
    errorMessage: {},
    mappingCurrent: null,
    mappingStatus: false,
    robotStatus: false,
    selected: { tool: { _id: 'select', name: 'Selector' } },
    mapObjects: {},
    pointCounter: localStorage.getItem("pointCounter") ? JSON.parse(localStorage.getItem("pointCounter")) : 0,
    helpers: { newItem: true },
    savingStatus: false,
    loadingMap: false,
    loadingPoints: false,
    orientation: true,
    acceleratorValue: 50,
    joystick: 0,
    robotPosition: null,
    forkHeight: 0,
    forkDiff: '0.15',
    load: false,
    lastDrop: localStorage.getItem("lastDrop") ? JSON.parse(localStorage.getItem("lastDrop")) : { point: '', height: '' },
    diagnosticSwitch: localStorage.getItem("diagnosticSwitch") ? JSON.parse(localStorage.getItem("diagnosticSwitch")) : false,
    diagnostic: "",
    diagnosticTime: new Date(),
    operation: {},
    mapFeedFull: {},
    selector: false,
    konvaPoints: [],
    konvaEdges: [],
    konvaAreas: [],
    changes: [],
    undone: [],
    mapDimensions: { width: 0, height: 0, resolution: null },
    levelValue: localStorage.getItem("levelValue") ? localStorage.getItem("levelValue") : [],
    areas: [],
    rosCommands: [
      { name: "zone_occupied_detection", value: "ros topic echo /wgo/zone_occupied_detection/warningMsg", typeRos: "ROS1", needs_value: false },
      { name: "zone_occupied_detection", value: "ros2 topic echo /wgo/zone_occupied_detection/warningMsg", typeRos: "ROS2", needs_value: false },
      { name: "PackVoltage", value: "rostopic echo PackVoltage", typeRos: "ROS1", needs_value: false },
      { name: "PackVoltage", value: "ros2 topic echo /PackVoltage", typeRos: "ROS2", needs_value: false },
      { name: "Read_Block_Decoded", value: "rostopic  echo /PackVoltage", typeRos: "ROS1", needs_value: false },
      { name: "Read_Block_Decoded", value: "ros2 topic echo /Read_Block_Decoded", typeRos: "ROS2", needs_value: false },
      { name: "core/pause", value: "rostopic echo /core/pause", typeRos: "ROS1", needs_value: false, messageType: "std_msgs/Bool" },
      { name: "core/pause", value: "ros2 topic echo /core/pause", typeRos: "ROS2", needs_value: false, messageType: "std_msgs/msg/Bool" },
      { name: "core/state", value: "rostopic echo /core/state", typeRos: "ROS1", needs_value: false, messageType: "std_msgs/String" },
      { name: "core/state", value: "ros2 topic echo /core/state", typeRos: "ROS2", needs_value: false, messageType: "std_msgs/msg/String" },
      { name: "scan_front", value: "rostopic echo /scan_front", typeRos: "ROS1", needs_value: false, messageType: "sensor_msgs/LaserScan" },
      { name: "scan_front", value: "ros2 topic echo /scan_front", typeRos: "ROS2", needs_value: false, messageType: "sensor_msgs/msg/LaserScan" },
      { name: "scan_front_raw", value: "rostopic echo /scan_front_raw", typeRos: "ROS1", needs_value: false, messageType: "sensor_msgs/LaserScan" },
      { name: "scan_front_raw", value: "ros2 topic echo /scan_front_raw", typeRos: "ROS2", needs_value: false, messageType: "sensor_msgs/msg/LaserScan" },
      { name: "scan_rear", value: "rostopic echo /scan_rear", typeRos: "ROS1", needs_value: false, messageType: "sensor_msgs/LaserScan" },
      { name: "scan_rear", value: "ros2 topic echo /scan_rear", typeRos: "ROS2", needs_value: false, messageType: "sensor_msgs/msg/LaserScan" },
      { name: "scan_rear_raw", value: "rostopic echo /scan_rear_raw", typeRos: "ROS1", needs_value: false, messageType: "sensor_msgs/LaserScan" },
      { name: "scan_rear_raw", value: "ros2 topic echo /scan_rear_raw", typeRos: "ROS2", needs_value: false, messageType: "sensor_msgs/msg/LaserScan" },
      { name: "system_diagnostic", value: "rostopic echo /wgo/alive_signal/system_diagnostic", typeRos: "ROS1", needs_value: false, messageType: "diagnostic_msgs/DiagnosticArray" },
      { name: "system_diagnostic", value: "ros2 topic echo /wgo/alive_signal/system_diagnostic", typeRos: "ROS2", needs_value: false, messageType: "diagnostic_msgs/msg/DiagnosticArray" },
      { name: "diagnostic_errors", value: "rostopic echo /wgo/alive_signal/diagnostic_errors", typeRos: "ROS1", needs_value: false, messageType: "std_msgs/String" },
      { name: "diagnostic_errors", value: "ros2 topic echo /wgo/alive_signal/diagnostic_errors", typeRos: "ROS2", needs_value: false, messageType: "std_msgs/msg/String" },
      { name: "diagnostic_fatals", value: "rostopic echo /wgo/alive_signal/diagnostic_fatals", typeRos: "ROS1", needs_value: false, messageType: "std_msgs/String" },
      { name: "diagnostic_fatals", value: "ros2 topic echo /wgo/alive_signal/diagnostic_fatals", typeRos: "ROS2", needs_value: false, messageType: "std_msgs/msg/String" },
      { name: "diagnostic_notices", value: "rostopic echo /wgo/alive_signal/diagnostic_notices", typeRos: "ROS1", needs_value: false, messageType: "std_msgs/String" },
      { name: "diagnostic_notices", value: "ros2 topic echo /wgo/alive_signal/diagnostic_notices", typeRos: "ROS2", needs_value: false, messageType: "std_msgs/msg/String" },
      { name: "diagnostic_warnings", value: "rostopic echo /wgo/alive_signal/diagnostic_warnings", typeRos: "ROS1", needs_value: false, messageType: "std_msgs/String" },
      { name: "diagnostic_warnings", value: "ros2 topic echo /wgo/alive_signal/diagnostic_warnings", typeRos: "ROS2", needs_value: false, messageType: "std_msgs/msg/String" },
      { name: "battery_status", value: "rostopic echo /wgo/battery_indicator/battery_status", typeRos: "ROS1", needs_value: false, messageType: "sensor_msgs/BatteryState" },
      { name: "battery_status", value: "ros2 topic echo /wgo/battery_indicator/battery_status", typeRos: "ROS2", needs_value: false, messageType: "sensor_msgs/msg/BatteryState" },
      { name: "charge_controller/status", value: "rostopic echo /wgo/charge_controller/status", typeRos: "ROS1", needs_value: false, messageType: "std_msgs/String" },
      { name: "charge_controller/status", value: "ros2 topic echo /wgo/charge_controller/status", typeRos: "ROS2", needs_value: false, messageType: "std_msgs/msg/String" },
      { name: "emergency_status", value: "rostopic echo /wgo/emergency_indicator/emergency_status", typeRos: "ROS1", needs_value: false, messageType: "std_msgs/Bool" },
      { name: "emergency_status", value: "ros2 topic echo /wgo/emergency_indicator/emergency_status", typeRos: "ROS2", needs_value: false, messageType: "std_msgs/msg/Bool" },
      { name: "currentTask_hack", value: "rostopic echo /wgo/fms/currentTask_hack", typeRos: "ROS1", needs_value: false, messageType: "std_msgs/String" },
      { name: "currentTask_hack", value: "ros2 topic echo /wgo/fms/currentTask_hack", typeRos: "ROS2", needs_value: false, messageType: "std_msgs/msg/String" },
      { name: "fork_indicator-fork_height", value: "rostopic echo /wgo/fork_indicator/fork_height", typeRos: "ROS1", needs_value: false, messageType: "std_msgs/Float32" },
      { name: "fork_indicator-fork_height", value: "ros2 topic echo /wgo/fork_indicator/fork_height", typeRos: "ROS2", needs_value: false, messageType: "std_msgs/msg/Float32" },
      { name: "localization_confidence", value: "rostopic echo /wgo/localization_confidence/confidence", typeRos: "ROS1", needs_value: false, messageType: "std_msgs/Float32" },
      { name: "localization_confidence", value: "ros2 topic echo /wgo/localization_confidence/confidence", typeRos: "ROS2", needs_value: false, messageType: "std_msgs/msg/Float32" },
      { name: "odometry-odom", value: "rostopic echo /wgo/odometry/odom", typeRos: "ROS1", needs_value: false, messageType: "nav_msgs/Odometry" },
      { name: "odometry-odom", value: "ros2 topic echo /wgo/odometry/odom", typeRos: "ROS2", needs_value: false, messageType: "nav_msgs/msg/Odometry" },
      { name: "move_base-cmd_vel", value: "rostopic echo /wgo/move_base/cmd_vel", typeRos: "ROS1", needs_value: false, messageType: "geometry_msgs/Twist" },
      { name: "move_base-cmd_vel", value: "ros2 topic echo /wgo/move_base/cmd_vel", typeRos: "ROS2", needs_value: false, messageType: "geometry_msgs/msg/Twist" },
      { name: "cancelTask", value: "rostopic echo /wgo/fms/cancelTask", typeRos: "ROS1", needs_value: false, messageType: "std_msgs/Bool" },
      { name: "cancelTask", value: "ros2 topic echo /wgo/fms/cancelTask", typeRos: "ROS2", needs_value: false, messageType: "std_msgs/msg/Bool" },
      { name: "alive_signal", value: "rostopic echo /wgo/alive_signal", typeRos: "ROS1", needs_value: false, messageType: "std_msgs/Bool" },
      { name: "alive_signal", value: "ros2 topic echo /wgo/alive_signal", typeRos: "ROS2", needs_value: false, messageType: "std_msgs/msg/Bool" },
      { name: "battery_indicator", value: "rostopic echo /wgo/battery_indicator/battery_status", typeRos: "ROS1", needs_value: false, messageType: "sensor_msgs/BatteryState" },
      { name: "battery_indicator", value: "ros2 topic echo /wgo/battery_indicator/battery_status", typeRos: "ROS2", needs_value: false, messageType: "sensor_msgs/msg/BatteryState" },
      { name: "zone_controller", value: "rostopic echo /wgo/zone_controller/zones", typeRos: "ROS1", needs_value: false, messageType: "std_msgs/String" },
      { name: "zone_controller", value: "ros2 topic echo /wgo/zone_controller/zones", typeRos: "ROS2", needs_value: false, messageType: "std_msgs/msg/String" },
      { name: "zone_occupied_detection pub", value: "ros2 topic /wgo/zone_occupied_detection/warningMsg std_msgs/msg/String ", typeRos: "ROS2", needs_value: true },
      { name: "security-enable", value: "rostopic pub /wgo/security/enable std_msgs/Bool", typeRos: "ROS1", needs_value: true, messageType: "std_msgs/Bool" },
      { name: "security-enable", value: "ros2 topic pub /wgo/security/enable std_msgs/msg/Bool", typeRos: "ROS2", needs_value: true, messageType: "std_msgs/msg/Bool" },
      { name: "TaskFeedback", value: "rostopic echo /wgo/task_manager/TaskFeedback", typeRos: "ROS1", needs_value: false, messageType: "custom_msgs/TaskFeedback" },
      { name: "TaskFeedback", value: "ros2 topic echo /wgo/task_manager/TaskFeedback", typeRos: "ROS2", needs_value: false, messageType: "custom_msgs/msg/TaskFeedback" },
      { name: "current_position", value: "rostopic echo /wgo/current_position", typeRos: "ROS1", needs_value: false, messageType: "geometry_msgs/Pose" },
      { name: "current_position", value: "ros2 topic echo /wgo/current_position", typeRos: "ROS2", needs_value: false, messageType: "geometry_msgs/msg/Pose" },
      { name: "joy_mux_cmd_vel", value: "rostopic echo /wgo/joy_mux/cmd_vel", typeRos: "ROS1", needs_value: false, messageType: "geometry_msgs/Twist" },
      { name: "joy_mux_cmd_vel", value: "ros2 topic echo /wgo/joy_mux/cmd_vel", typeRos: "ROS2", needs_value: false, messageType: "geometry_msgs/msg/Twist" },
      { name: "joy_mux_joy_state", value: "rostopic echo /wgo/joy_mux/joy_state", typeRos: "ROS1", needs_value: false, messageType: "std_msgs/String" },
      { name: "joy_mux_joy_state", value: "ros2 topic echo /wgo/joy_mux/joy_state", typeRos: "ROS2", needs_value: false, messageType: "std_msgs/msg/String" },
    ],
    features: localStorage.getItem("features") ? JSON.parse(localStorage.getItem("features")) : [false, false, false, false]
  }

  actions = {
    setMapFeedFull: (map) => {
      //console.log(map)
      this.setState({ mapFeedFull: map })
    },

    setMapDimensions: (info) => {
      this.setState({ mapDimensions: info })
    },

    setSelector: (selector) => this.setState({ selector: selector }),

    setKonvaPoints: (points) => this.setState({ konvaPoints: points }),

    setKonvaEdges: (edges) => this.setState({ konvaEdges: edges }),

    setKonvaAreas: (areas) => this.setState({ konvaAreas: areas }),

    setChanges: (changes) => this.setState({ changes: changes }),

    setUndone: (undone) => this.setState({ undone: undone }),

    setApiToken: (token) => {
      this.setState({ apiToken: token })
      console.log("connection token updated")
    },

    setBattery: (percentage) => {
      this.setState({ battery: percentage })
    },

    setAvailableRobots: (robots) => {
      this.setState({ availableRobots: robots })
    },

    setAvailableActions: (actions) => {
      this.setState({ availableActions: actions })
    },

    setSelectedRobot: (robot) => {
      this.setState({ selectedRobot: robot })
      // console.log("context: selecting robot", robot)
    },
    setAvailableMissions: (missions) => {
      this.setState({ availableMissions: missions })
      // console.log("context: setting available missions", missions)
    },

    setAvailableTriggers: (triggers) => {
      this.setState({ availableTriggers: triggers })
      // console.log("context: setting available triggers", triggers)
    },

    setRobotPosition: (position) => {
      if (this.validatePostion(this.state.robotPosition, position)) {
        this.setState({ robotPosition: position })
      }
    },
    setDiagnostic: (diagnostic) => {
      // if (this.validatePostion(this.state.robotPosition,position)) {
      this.setState({ diagnostic: diagnostic })
      // }
    },
    setDiagnosticTime: (diagnosticTime) => {
      // if (this.validatePostion(this.state.robotPosition,position)) {
      this.setState({ diagnosticTime: diagnosticTime })
      // }
    },
    setSelectedTypeRobot: (typeRobot) => {
      this.setState({ typeRobot: typeRobot })
      // console.log("context: selecting Type robot", typeRobot)
    },

    setUser: (user) => {
      this.setState({ user: user })
      // console.log("context: setting user to ", user)
    },
    setArea: (areas) => {
      this.setState({ areas: areas })
    },

    setSelectedUser: (userId) => {
      this.setState({ selectedUser: userId })
      // console.log("context: setting selectedUser to ", userId)
    },

    setAvailableTasks: (tasks) => {
      this.setState({ availableTasks: tasks })
      // console.log("context: setting available tasks", tasks)
    },
    setRobotConfiguration: (robot) => {
      this.setState({ robotConfiguration: robot })
      // console.log("context: setting Configuration by new Robots IP", robot)
    },

    setImportExcel: (importExcel) => {
      this.setState({ importExcel: importExcel })
      // console.log("context: setting import excel", importExcel)
    },

    setAvailablePoints: (points) => {
      this.setState({ availablePoints: points })
      // console.log("context: setting available points", points)
    },
    setSavingStatus: (val) => this.setState({ savingStatus: val }),

    setLoadingMap: (val) => this.setState({ loadingMap: val }),

    setLoadingPoints: (val) => this.setState({ loadingPoints: val }),

    setLastDrop: (val) => this.setState({ lastDrop: val }),

    setOrientation: (val) => this.setState({ orientation: val }),

    setAcceleratorValue: (val) => this.setState({ acceleratorValue: val }),

    setJoystick: (val) => this.setState({ joystick: val }),

    setPointNames: (names) => this.setState({ pointNames: names }),

    setFirstLoad: () => this.setState({ firstLoad: false }),

    setModalState: (mState) => this.setState({ modalState: mState }),

    setIsRobotConnected: (val) => this.setState({ isRobotConnected: val }),

    setScanRobots: (scan) => this.setState({ scanRobots: scan }),

    setMapIndex: (val) => {
      // console.log("context setting map index", val)
      this.setState({ mapIndex: val })
    },
    setMapOrientation: (val) => {
      this.setState({ mapOrientation: val })
    },


    setMapFeed: (val) => this.setState({ mapFeed: val }),

    setDestinations: (val) => {
      if (this.state.destinations.indexOf(val) < 0) this.setState({ destinations: [...this.state.destinations, val] })
    },

    setCurrentTask: (val) => this.setState({ currentTask: val }),

    setForkHeight: (val) => this.setState({ forkHeight: val }),

    setLoad: (val) => this.setState({ load: val }),

    setOrderStatus: (val) => this.setState({ orderStatus: val }),

    setFoundPeople: (val) => this.setState({ foundPeople: val }),

    setSettings: (val) => this.setState({ settings: val }),

    setErrorMessage: (val) => this.setState({ errorMessage: val }),

    setCurrentMission: (val) => this.setState({ currentMission: val }),

    setMessage: (val) => this.setState({ message: val }),

    setOperation: (val) => this.setState({ operation: val }),

    setLastMission: (val) => this.setState({ lastMission: val }),

    setLevelValue: (val) => this.setState({ levelValue: val }),

    setForkDiff: (val) => this.setState({ forkDiff: val }),

    setPalletHeight: (val) => this.setState({ palletHeight: val }),

    setPalletWeight: (val) => this.setState({ palletWeight: val }),

    setEndOfMission: (val) => {

      let update = {}

      //status: 'executing'
      //name: 'Pick_Wall'
      //actions: [{name: 'go-to-and-orientate', status: 'navigationStatus'}]
      this.actions.setLastMission(val.name)

      if (val?.status === "executing" && Array.isArray(val?.actions) && val?.actions[0].name === "GotoMachine") {
        if (!this.state.orderStatus) this.actions.setOrderStatus(true)
      } else {
        if (this.state.orderStatus) this.actions.setOrderStatus(false)
      }

      // end of mission
      if ((val?.status === "cancelled" || val?.status === "finished")) {
        if (!this.state.endOfMission) update.endOfMission = true
      } else {
        if (this.state.endOfMission) update.endOfMission = false
      }

      //Loading map
      if (val?.status === "executing" && val?.actions[0]?.name === "SelectMapMachine") {
        if (!this.state.loadingMap) this.actions.setLoadingMap(true)
        if (!this.state.loadingPoints) this.actions.setLoadingPoints(true)

      } else {
        if (this.state.loadingMap) this.actions.setLoadingMap(false)
        if (this.state.loadingPoints) this.actions.setLoadingPoints(false)
      }

      // watch mapping
      if (val?.status === "executing" && (val?.name === "map" || val?.name === "soft-map")) {
        if (val.actions[0].status === "savingMapStatus") this.actions.setSavingStatus(true)
        if (!this.state.mappingStatus) update.mappingStatus = true

      } else {
        if (this.state.savingStatus) this.actions.setSavingStatus(false)
        if (this.state.mappingStatus) update.mappingStatus = false

      }

      // watch blocks
      if (val?.status === "executing" && val?.actions[0]?.status === "blockedStatus") {
        if (!this.state.robotStatus) {
          update.robotStatus = true
          update.modalState = { ...this.state.modalState, disconnect: true }
        }
      } else {
        if (this.state.robotStatus) {
          update.robotStatus = false
          update.modalState = { ...this.state.modalState, disconnect: false }
        }
      }

      //if (update.endOfMission || update.mappingStatus || update.robotStatus || update.modalState) {
      // console.log("updating #########", update)
      this.setState(update)
      //}
    },

    setMappingStatus: (val) => {
      if (val?.status !== this.state.mappingStatus?.status) {
        this.setState({ mappingStatus: val })
      }
    },

    setRobotStatus: (val) => {
      // console.log("setting robot status", val)
      if (val !== this.state.robotStatus) {
        this.setState({ robotStatus: val })
      }
    },

    setMaps: (val) => {
      console.log("context setting maps", val)
      this.setState({ maps: val })
    },

    setMappingCurrent: (val) => {
      this.setState({ mappingCurrent: val })
    },

    setDiagnosticSwitch: (val) => {
      this.setState({ diagnosticSwitch: val })
    },

    setRobotInfo: (val) => this.setState({ robotInfo: val }),

    setSelected: (val) => {
      console.log(val.tool)
      this.setState({ selected: { ...this.state.selected, ...val } })
    },

    setMapObjects: (val) => this.setState({ mapObjects: val }),

    setPointCounter: (val) => this.setState({ pointCounter: val }),

    setHelpers: (val) => this.setState({ helpers: val }),

    setFeatures: (feat) => this.setState({ features: feat }),
  }


  validatePostion(lastPostion, newPostion) {
    if (lastPostion?.position?.x.toFixed(4) != newPostion?.position?.x.toFixed(4)
      || lastPostion?.position?.y.toFixed(4) != newPostion?.position?.y.toFixed(4)
      || lastPostion?.position?.z.toFixed(4) != newPostion?.position?.z.toFixed(4)) {
      return true
    } else {
      return false
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.mapDimensions !== prevState.mapDimensions)
      localStorage.setItem("mapDimensions", JSON.stringify(this.state.mapDimensions))
    if (this.state.apiToken !== prevState.apiToken)
      localStorage.setItem("apiToken", this.state.apiToken)
    if (this.state.user !== prevState.user)
      localStorage.setItem("user", JSON.stringify(this.state.user))
    if (this.state.selectedRobot !== prevState.selectedRobot)
      localStorage.setItem("selectedRobot", JSON.stringify(this.state.selectedRobot))
    if (this.state.availableTasks !== prevState.availableTasks)
      localStorage.setItem("availableTasks", JSON.stringify(this.state.availableTasks))
    if (this.state.availableMissions !== prevState.availableMissions)
      localStorage.setItem("availableMissions", JSON.stringify(this.state.availableMissions))
    if (this.state.availableTriggers !== prevState.availableTriggers)
      localStorage.setItem("availableTriggers", JSON.stringify(this.state.availableTriggers))
    if (this.state.availableActions !== prevState.availableActions)
      localStorage.setItem("availableActions", JSON.stringify(this.state.availableActions))
    if (this.state.destinations !== prevState.destinations)
      localStorage.setItem("destinations", JSON.stringify(this.state.destinations))
    if (this.state.maps !== prevState.maps)
      localStorage.setItem("maps", JSON.stringify(this.state.maps))
    if (this.state.mapIndex !== prevState.mapIndex)
      localStorage.setItem("mapIndex", JSON.stringify(this.state.mapIndex))
    if (this.state.mapOrientation !== prevState.mapOrientation)
      localStorage.setItem("mapOrientation", JSON.stringify(this.state.mapOrientation))
    if (this.state.robotConfiguration !== prevState.robotConfiguration)
      localStorage.setItem("robotConfiguration", JSON.stringify(this.state.robotConfiguration))
    if (this.state.importExcel !== prevState.importExcel)
      localStorage.setItem("importExcel", JSON.stringify(this.state.importExcel))
    if (this.state.settings !== prevState.settings)
      localStorage.setItem("settings", JSON.stringify(this.state.settings))
    if (this.state.errorMessage !== prevState.errorMessage)
      localStorage.setItem("errorMessage", JSON.stringify(this.state.errorMessage))
    if (this.state.message !== prevState.message)
      localStorage.setItem("message", JSON.stringify(this.state.message))
    if (this.state.mappingCurrent !== prevState.mappingCurrent)
      localStorage.setItem("mappingCurrent", JSON.stringify(this.state.mappingCurrent))
    if (this.state.diagnosticSwitch !== prevState.diagnosticSwitch)
      localStorage.setItem("diagnosticSwitch", JSON.stringify(this.state.diagnosticSwitch))
    if (this.state.pointCounter !== prevState.pointCounter)
      localStorage.setItem("pointCounter", JSON.stringify(this.state.pointCounter))
    if (this.state.mapFeedFull !== prevState.mapFeedFull)
      localStorage.setItem("mapFeedFull", JSON.stringify(this.state.mapFeedFull))
    if (this.state.selector !== prevState.selector)
      localStorage.setItem("selector", JSON.stringify(this.state.selector))
    if (this.state.konvaPoints !== prevState.konvaPoints)
      localStorage.setItem("konvaPoints", JSON.stringify(this.state.konvaPoints))
    if (this.state.konvaEdges !== prevState.konvaEdges)
      localStorage.setItem("konvaEdges", JSON.stringify(this.state.konvaEdges))
    if (this.state.konvaAreas !== prevState.konvaAreas)
      localStorage.setItem("konvaAreas", JSON.stringify(this.state.konvaAreas))
    if (this.state.changes !== prevState.changes)
      localStorage.setItem("changes", JSON.stringify(this.state.changes))
    if (this.state.undone !== prevState.undone)
      localStorage.setItem("undone", JSON.stringify(this.state.undone))
    if (this.state.levelValue !== prevState.levelValue)
      localStorage.setItem("levelValue", JSON.stringify(this.state.levelValue))
    if (this.state.areas !== prevState.areas)
      localStorage.setItem("areas", JSON.stringify(this.state.areas))
    if (this.state.features !== prevState.features)
      localStorage.setItem("features", JSON.stringify(this.state.features))
  }

  render() {
    const context = { ...this.state, actions: this.actions }
    return (
      <Context.Provider value={context} loggedIn={context.loggedIn}>
        {this.props.children}
      </Context.Provider>
    )
  }
}
